/**
 * When true, all required resource fields are always enforced on edit
 * (including fields with originalRequiredField: false).
 * When false, legacy records created before requireAllRequiredResourceFieldsDate
 * only enforce fields marked originalRequiredField: true.
 */
export const requireAllRequiredResourceFields = false;

/** ISO date (YYYY-MM-DD). Records created before this date may get legacy required-field rules. */
export const requireAllRequiredResourceFieldsDate = '2026-09-29';
